export const PLATFORM_READY_TAG = 'Platform-Ready';
